import SharedCustomers from "../classes/SharedCustomers";

const state = {
  data: {}
};

// getters
const getters = {
  customer: () => {
    return state.data;
  },
  amocrm: () => {
    try {
      return state.data._embedded.sharedAmocrm;
    } catch (e) {
      return null;
    }
  },
  contacts: () => {
    try {
      return state.data._embedded.sharedContacts;
    } catch (e) {
      return null;
    }
  }
};

// actions
const actions = {
  shared_customers(state, data) {
    state.commit("setData", JSON.parse(JSON.stringify(data)));
  }
};

// mutations
const mutations = {
  setData(state, data) {
    state.data = new SharedCustomers(data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
